import { api } from '../creat-api'

// 节目审核查询接口
export function queryProgramForAudit (params) {
  return api({
    url: '/programs/queryProgramForAudit',
    params
  })
}
// 节目集审核查询接口
export function queryProgramSetsForAudit (params) {
  return api({
    url: '/programSets/queryProgramSetsForAudit',
    params
  })
}

// 节目批量审核接口
export function auditProgram (params) {
  return api({
    method: 'POST',
    url: '/audit/program',
    data: params
  })
}

// 节目集批量审核接口
export function auditProgramSet (params) {
  return api({
    method: 'POST',
    url: '/audit/programSet',
    data: params
  })
}

// 单个节目审核接口
export function programSingleAudit (params) {
  return api({
    url: `/audit/program/${params}`
  })
}

// 单个节目集审核接口
export function programSetSingleAudit (params) {
  return api({
    url: `/audit/programSet/${params}`
  })
}
// 节目和节目集的初审、复审、终审审核状态查询

export function fetchByResourceId (params) {
  return api({
    url: '/audits/ByResourceId',
    params
  })
}
